import logger from '../utils/logger-rum';
import Socket from '../connection/socket';
import * as BroadcastActions from '../stores/actions/broadcasting';
import * as SessionActions from '../stores/actions/session';
import { extractBitrate, extractFps, extractHealth } from '../utils/utils';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { showAlert } from '../components/general-components/alert-service';
import { BROADCAST_STATES, STREAM_STATES } from '../stores/types/broadcasting';

function updateDatabaseStreamState(state: number) {
	const { SessionReducer: { host, token, meeting } } = getState();
	if (host && token && meeting) {
		socketListenerDispatch(BroadcastActions.setDatabaseStreamState(token!, meeting.meeting, state));
	}
}

function handleAlertToaster() {
	showAlert({
		message: 'Broadcast reset in progress',
		description: 'Allow 5 minutes for this process to complete before attempting to restart your broadcast.',
		duration: 7000,
		type: 'error',
	});
}

function handleBroadcastStart() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.BROADCAST_STARTING));
}

function handleBroadcastStop() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.BROADCAST_STOPPED));
}

function handleBroadcastSuccess() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.BROADCAST_STARTED));
}

function handleBroadcastFailure(message: string) {
	const ddLog = {
		family: 'BroadcastState',
		event: 'socketEvent',
		location: 'socket-listeners/braodcasting.ts',
		function: 'handleBroadcastFailure',
		error: message,
	};
	logger.error('Broadcast failed socket msg', ddLog);
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.BROADCAST_FAILED));
}

function handleBroadcastStarting() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.STARTING_UP));
}

function handleBroadcastServerReady() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.READY));
}

function handleBroadcastServerKilled() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.KILLED));
}

function handleBroadcastPrewarming() {
	socketListenerDispatch(BroadcastActions.setBroadcastState(BROADCAST_STATES.BROADCAST_PREWARMING));
}

function handleBroadcastPreShow() {
	socketListenerDispatch(BroadcastActions.setStreamState(STREAM_STATES.PRE));
	updateDatabaseStreamState(STREAM_STATES.PRE);
}

function handleBroadcastPostShow() {
	socketListenerDispatch(BroadcastActions.setStreamState(STREAM_STATES.POST));
	updateDatabaseStreamState(STREAM_STATES.POST);
}

function handleBroadcastMainShow() {
	const { SessionReducer: { meeting } } = getState();
	socketListenerDispatch(BroadcastActions.setStreamState(STREAM_STATES.MAIN));

	// dont want premedia to count as part of the live timer
	socketListenerDispatch(SessionActions.setSelectedMeeting({
		...meeting,
		broadcast_live_start_time: new Date(),
	}));
	updateDatabaseStreamState(STREAM_STATES.MAIN);
}

function handleBroadcastOffShow() {
	socketListenerDispatch(BroadcastActions.setStreamState(STREAM_STATES.OFF));
	updateDatabaseStreamState(STREAM_STATES.OFF);
}

function handleBroadcastStats(message: any) {
	socketListenerDispatch(
		BroadcastActions.setBroadcastStats({
			bitrate: extractBitrate(message.message),
			fps: extractFps(message.message),
			health: extractHealth(message.message),
		}),
	);
}

export default function Broadcasting(socket: Socket) {
	const {
		SessionReducer: {
			host,
		},
	} = getState();

	socket.addListener('broadcast-start', handleBroadcastStart);
	socket.addListener('broadcast-stop', handleBroadcastStop);
	socket.addListener('broadcast-success', handleBroadcastSuccess);
	socket.addListener('broadcast-failure', handleBroadcastFailure);
	socket.addListener('broadcast-stats', handleBroadcastStats);
	socket.addListener('broadcast-server-starting', handleBroadcastStarting);
	socket.addListener('broadcast-server-ready', handleBroadcastServerReady);
	socket.addListener('broadcast-pre-show', handleBroadcastPreShow);
	socket.addListener('broadcast-post-show', handleBroadcastPostShow); // moved to main video for stream state ref in timeout
	socket.addListener('broadcast-main-show', handleBroadcastMainShow);
	socket.addListener('broadcast-off-show', handleBroadcastOffShow);
	socket.addListener('broadcast-server-killed', handleBroadcastServerKilled);

	if (host) {
		socket.addListener('someone-pressed-reset-broadcast', handleAlertToaster);
		socket.addListener('broadcast-server-prewarming-fail', handleBroadcastFailure);
		socket.addListener('broadcast-server-prewarming', handleBroadcastPrewarming);
	}
}
